module.exports = __webpack_public_path__ + "static/images/backpack-error.5951c57.png";